module.exports = __webpack_public_path__ + "img/dropshadow_stickynav.4e2698d7c5d0b9833010bfb5c9f75c6d.png";